<template>

  <el-dialog
    width="30%"
    :visible.sync="visible"
    :show-close="false"
    :close-on-press-escape="false"
    :close-on-click-modal="false"
    :modal="true"
  >

    <div class="form-modal">

      <h2 class="form-section-header">
        {{ context === 'create' ? 'Create layout' : 'Edit layout' }}
      </h2>

      <el-input
        v-model="name"
        id="name-input"
        placeholder="Enter name"
      >
        <template slot="prefix">
          Name
        </template>
      </el-input>

      <el-select
        v-model="selectedQueues"
        placeholder="Select queues"
        clearable
        multiple
        :multiple-limit="15"
        filterable
        style="margin-top: 0;"
      >
        <el-option
          v-for="item in queueOptions"
          :key="item.id"
          :value="item.id"
          :label="item.name"
        />
        <template slot="prefix">
          <span style="opacity: 0">Queues</span>
        </template>
      </el-select>

      <el-button
        @click="cancel"
      >
        Cancel
      </el-button>

      <el-button
        @click="submit"
      >
        Submit
      </el-button>
    </div>

  </el-dialog>

</template>

<script>


export default {
  name: 'QueueLayoutForm',
  props: {
    visible: {required: true},
    context: {required: true},
    layoutData: {required: true},
    queueOptions: {required: true}
  },
  data() {
    return {
      name: "",
      selectedQueues: []
    }
  },
  watch: {
    visible(){
      //load form
      if(this.visible){

        //auto focus the input
        setTimeout(() => {
          if(!this.layoutData){
            document.getElementById('name-input').focus();
          }
        }, 100);


        //populate form if this is edit
        if(this.layoutData){
          this.name = this.layoutData.name;
          this.selectedQueues = this.layoutData.queueIds;
        }
      }
    }
  },
  methods: {
    async createLayout() {

      try {
        await this.$confirm('Create new layout?');
      } catch (e) {
        console.log('create layout cancelled', e);
        return;
      }


      const isValid = this.validateLayoutFields({name: this.name, queueIds: this.selectedQueues});
      if(!isValid){
        this.$notify({
          title: "Invalid Data",
          message: "You must include a name and selected queues",
          type: "error"
        });
        return;
      }

      this.$emit('create', {
        name: this.name,
        queueIds: this.selectedQueues
      });

      this.$emit('close');
      this.clearFields();

    },

    async saveLayout() {

      try {
        await this.$confirm('Save current layout?');
      } catch (e) {
        console.log('edit layout cancelled', e);
        return;
      }

      const isValid = this.validateLayoutFields({name: this.name, queueIds: this.selectedQueues});
      if(!isValid){
        this.$notify({
          title: "Invalid Data",
          message: "You must include a name and selected queues",
          type: "error"
        });
        return;
      }

      this.$emit('save', {
        name: this.name,
        queueIds: this.selectedQueues
      })

      this.$emit('close');
      this.clearFields();

    },

    //check the fields for the layout before creating
    validateLayoutFields(data) {
      const { name, queueIds } = data;
      if(!name.length) return false;
      if(typeof queueIds !== 'object') return false;
      return queueIds && queueIds.length;
    },

    cancel() {
      this.$emit('close');
      this.clearFields();
    },

    submit() {
      this.context === 'create' ? this.createLayout() : this.saveLayout();
    },

    clearFields() {
      this.name = "";
      this.selectedQueues = [];
    }

  }

}

</script>
